import CONFIG from "../config";
import type { ItemReponse, ServerReponse } from "../types/CommonReponse";
interface NotificationParams{
    template:string,
    dest: string|number,
    params: Record<string,unknown>
}


export function SendNotification({params}:{params:NotificationParams}){
    return fetch(CONFIG.SERVER + '/ws/utils/notify',{
        method: "POST", 
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(params),

    })
    .then(response=>{
        return response.json().then((data:ServerReponse<null>)=>{
            const payload:ItemReponse<null>={success:response.ok,...data}
            return payload;
        });
    })
    .then((data:ItemReponse<null>)=>{
       return data.success;
    });
}

interface NotificationMessages{
    messages:string[]
}

interface UserValidationErrorParams{
    dest: string|number,
    params: NotificationMessages
}

export function SendUserValidationErrorNotification(params:UserValidationErrorParams){
    return fetch(CONFIG.SERVER + '/utils/notify',{
        method: "POST", 
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({...params,template:"user_validation_errors"}),

    })
    .then(response=>{
        return response.json().then((data:ServerReponse<null>)=>{
            const payload:ItemReponse<null>={success:response.ok,...data}
            return payload;
        });
    })
    .then((data:ItemReponse<null>)=>{
       return data.success;
    }).catch(()=>{
        console.log("error");
    });
}